import SiteHeader from "@/components/SiteHeader";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import AboutSection from "@/components/AboutSection";
import HowItWorks from "@/components/HowItWorks";
import ContactSection from "@/components/ContactSection";
import SiteFooter from "@/components/SiteFooter";
import ChatLauncher from "@/components/ChatLauncher";
import BlogCarouselSection from "@/components/BlogCarousel";
import GoogleReviewsSection from "@/components/GoogleReviewsSection";
import FAQSection from "@/components/FAQSection";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <GoogleReviewsSection />
        <HowItWorks />
        <ContactSection />
        <FAQSection />
        <BlogCarouselSection heading="Tech tips from the blog" />
      </main>
      <SiteFooter />
      <ChatLauncher />
    </div>
  );
};

export default Index;
